import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=347d01f9&"
import script from "./app-bar.component.ts?vue&type=script&lang=ts&"
export * from "./app-bar.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports